import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageview } from "@/lib/analytics";

/**
 * Fires a GA4 `page_view` and a Meta Pixel `PageView` on every route change,
 * including the initial mount.
 *
 * The initial pageview from index.html is suppressed:
 *  - GA4: `gtag('config', ID, { send_page_view: false })`
 *  - Meta Pixel: the inline `fbq('track','PageView')` call has been removed.
 * So this hook is the single source of pageviews and there are no duplicates.
 */
export const useAnalyticsPageviews = () => {
  const { pathname, search } = useLocation();
  const lastPath = useRef<string | null>(null);

  useEffect(() => {
    const path = pathname + search;
    if (lastPath.current === path) return;
    lastPath.current = path;
    trackPageview(path, typeof document !== "undefined" ? document.title : undefined);
  }, [pathname, search]);
};